import React from 'react';
import { scroller } from "react-scroll";
import { portalMode, adminRole } from '../../config';
import { PODLASKIE_MODE } from '../../constants'
import RODO_CONTENT from '../utils/rodo';
import TermsOfUse from '../utils/termsOfUse/termsOfUse';
import PrivacyPolicy from '../utils/privacyPolicy/privacyPolicy';
import waiting from '../../routes/eserviceSummary/waiting-wheel-300x300.gif';

function collectionHas(a, b) { // helper function (see below)
  for (var i = 0, len = a.length; i < len; i++) {
    if (a[i] == b) return true;
  }
  return false;
}
export default function findParentBySelector(elm, selector) {
  var all = document.querySelectorAll(selector);
  var cur = elm.parentNode;
  while (cur && !collectionHas(all, cur)) { // keep going up until you find a match
    cur = cur.parentNode; // go up
  }
  return cur; // will return null if not found
}

export const removeChildNode = (parentNode, childNodeClass) => {
  const chNodes = parentNode.childNodes;
  const chNodesArray = [...chNodes];
  const chNodeIndex = chNodesArray.findIndex(item => item.classList.contains(childNodeClass));
  // if (parentNode.childNodes[indexToRemove]) { parentNode.childNodes[indexToRemove].remove(); }
  if (parentNode.childNodes[chNodeIndex]) { parentNode.childNodes[chNodeIndex].style.display = 'none'; }
};

export const headerStyle = {
  normal: {
    backgroundColor: '#31485e',
    color: 'white',
  },
  intenseBlack: {
    backgroundColor: 'black',
    color: 'white',
  },
  intenseBlackYellow: {
    backgroundColor: 'black',
    color: 'yellow',
  },
  intenseYellowBlack: {
    backgroundColor: 'black',
    color: 'yellow',
  },
};

export const layoutColorStyle = {
  normal: {
    backgroundColor: portalMode == PODLASKIE_MODE ? '#FFFFFF' : '#f2f2f2',
    color: 'black',
  },
  intenseBlack: {
    backgroundColor: '#111212',
    color: 'white',
  },
  intenseBlackYellow: {
    backgroundColor: '#111212',
    color: 'yellow',
  },
  intenseYellowBlack: {
    backgroundColor: 'yellow',
    color: 'black',
  },
};

export const getThemeFromLocalStorage = () => {
  const cookie = localStorage.getItem('colorTheme') || 'normal';
  return cookie;
};

export const setFooterAndHeaderColors = (type=null) => {
  const colors = getThemeFromLocalStorage();
  let sourceStyle = headerStyle;
  let style = {
    color: sourceStyle[colors].color,
    backgroundColor: sourceStyle[colors].backgroundColor,
  };
  if (colors !== 'normal') {
    sourceStyle = headerStyle;
    style = {
      color: sourceStyle[colors].color,
      backgroundColor: sourceStyle[colors].backgroundColor,
    };
  }

  if (portalMode == PODLASKIE_MODE && colors == 'normal') {
    style = {
      color: type == 'footer' ? podlaskieFooterColor : podlaskieColor,
      backgroundColor: type == 'footer' ? podlaskieFooterBackgroundColor : podlaskieBackgroundColor
    };
  }

  return {colors, sourceStyle, style}
}

export const podlaskieColor = '#1D1E28';
export const podlaskieBackgroundColor = '#F3F3F4';
export const podlaskieFooterColor = '#FFFFFF';
export const podlaskieFooterBackgroundColor = '#1D1E28';
export const podlaskieLabelBackgroundColor = '#62B7FC';
export const podlaskieMainPageURL = 'https://ipodlaskie.pl'
export const epuapAttachmentsInfo = 
  <div style={{ marginTop: '20px', fontStyle: 'italic' }}>
    <p>Załączniki, które dodawane są do wniosku będą wysłane do Urzędu i możliwe do otworzenia przez Urząd.</p>
    <p>Po przejściu do podpisania wniosku na ePUAP nie będziesz miał możliwości ich podglądu.</p>
  </div>;

export const isMobileView = (window) => {
    return window.matchMedia('(max-width: 768px)').matches;
}

export const isTabletView = (window) => {
  return window.matchMedia('(min-width: 769px) and (max-width: 1024px)').matches;
}

export const renderHelpDesc = (isMobile, isTablet) => {
  return (
    <div className="help-desc">
      W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden z dwóch dostępnych sposobów wyboru działki:<br />
      <ol>
      <li> Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer działki. W celu dodania kolejnej działki należy powtórzyć czynność.</li>
      { isMobile || isTablet ?
        <li>Wskazać działkę w oknie mapy wykorzystując przycisk <img src="https://d30y9cdsu7xlg0.cloudfront.net/png/181386-200.png" alt="Wskaż działki na mapie" style={{ height: '18px', verticalAlign: 'middle' }}/>.</li>
        :
        <li>Wskazać działkę w oknie mapy wykorzystując przycisk <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.</li>
      }
      </ol>
      Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku <samp>"Odznacz wszystko"</samp>.
    </div>
  )
}

export const privacyPolicyTitle = <div style={{ textAlign: 'center' }}>
    <h4><b>Polityka prywatności i wykorzystywanie plików cookies PORTALU E-USŁUG E-SPDP</b></h4>
  </div>

export const termsOfUseTitle = <div style={{ textAlign: 'center' }}>
    <h4><b>Regulamin korzystania z PORTALU E-USŁUG E-SPDP realizowanego przez firmę GIAP Sp. z o.o.</b></h4>
  </div>

export const RodoTitle = <div style={{ textAlign: 'center' }}>
  <h4><b>Klauzula informacyjna RODO</b></h4>
  <p>Przeczytaj, jak przetwarzamy Twoje dane</p>
</div>

export const TitleDict = {
  privacyPolicy: privacyPolicyTitle,
  termsOfUse: termsOfUseTitle,
  rodo: RodoTitle
}

export const bodyDict = {
  privacyPolicy: <PrivacyPolicy/>,
  termsOfUse: <TermsOfUse/>,
  rodo: <RODO_CONTENT/>
}

export const scrollToSection = (field) => {
  const targetElement = document.getElementById(field) || document.querySelector(`[name="${field}"]`);
  if (targetElement) {
    scroller.scrollTo(field, {
      duration: 500,
      delay: 100,
      smooth: true,
      offset: -400,
    });
  }
};

export const statusMap = {
  STARTED: 'Płatność elektroniczna - niedokończona',
  PENDING: 'Płatność elektroniczna - oczekuje',
  waiting: 'Płatność elektroniczna - oczekuje',
  SUCCESS: 'Płatność elektroniczna - opłacono',
  FAILURE: 'Płatność elektroniczna - nieudana',
};

export const loadingTitle = 'Przesyłanie wniosku...';

export const loadingBody =
  (<div style={{ height: '100px' }}>
    <div style={{ textAlign: 'center' }}>
      <img alt="Loader" src={waiting} style={{ width: '150px', height: '150px' }} />
    </div>
    <p style={{ textAlign: 'center' }}>
      Trwa proces przesyłania wniosku na ePUAP w celu jego podpisania. Proszę czekać...
    </p>
  </div>);

export const paymentLoadingTitle = 'Proszę czekać...';

export const paymentLoadingBody =
  (<div style={{ height: '100px' }}>
    <div style={{ textAlign: 'center' }}>
      <img alt="Loader" src={waiting} style={{ width: '150px', height: '150px' }} />
    </div>
    <p style={{ textAlign: 'center' }}>
      Za chwilę zostaniesz przeniesiony do płatności elektronicznej. Proszę czekać...
    </p>
  </div>);

export const buttonPayStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px'
};

export const getTokenFromCookie = () => {
    const name = "auth_token=";
    const cookies = document.cookie.split(";");
    for (let c of cookies) {
      c = c.trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length);
      }
    }
    return null;
  }

export const isSuperAdminRole = (roles) => roles.includes(adminRole);



// WEBPACK FOOTER //
// src/components/utils/utils.js